import p from '../../../theme/palette';

export const styles = {
  border: {
    border: `1px solid ${p.avatarDefaultBorder}`,
    borderRadius: 5,
  },
};
